const state = {
    customLayout: {
        companyId: '',
        primaryColor: '',
        secondaryColor: '',
        logoWidth: '',
        logoBgColor: '',
        companyLogo: '',
        companyIcon: ''
    }
  };
  
  const getters = {
    getCustomLayout: (st) => {
      return st.customLayout
    }
  };
  
  const mutations = {
    setCustomLayout: (st, data) => {
      
      if(data){
        st.customLayout.primaryColor = data.primary_color
        st.customLayout.secondaryColor = data.secondary_color
        st.customLayout.logoWidth = data.logo_width
        st.customLayout.logoBgColor = data.logo_bgcolor
        st.customLayout.companyLogo = data.company_logo
        st.customLayout.companyIcon = data.company_icon
      }
    }
  };
  

  
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
  };
  